/**
 * Questo file viene usato per la creazione dei file di lingua spagnola
 * @type Object
 */
window.oLang = {}

require('./validazioni');
require('./errori');